var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 19a1 1 0 010 2H5a1 1 0 010-2h14zM2 19v2H0v-2h2zm21-5a1 1 0 010 2H5a1 1 0 010-2h18zM2 14v2H0v-2h2zm17-5a1 1 0 010 2H5a1 1 0 010-2h14zM2 9v2H0V9h2zm21-5a1 1 0 010 2H5a1 1 0 010-2h18zM2 4v2H0V4h2z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconHistory;